export default __webpack_public_path__ + "static/media/Screenshot (15).3074f2ed.png";